$(document).ready(function () {
    if (!$(".tv_tariffs_packages_wrapper").length) {
        return;
    }

    $(".more-info").on("click", function () {
        $(".popup")
            .removeClass("more-info-popup-open-left", "more-info-popup-close")
            .addClass("more-info-popup-close");
        let popup = $(this).parents(".tariff_price_wrapper").siblings(".popup");

        $("body").off("click");
        setTimeout(function () {
            $("body")
                .not(".popup")
                .on("click", function (e) {
                    $(popup).attr("class", "more-info-popup-close popup");
                });
        }, 500);

        if ($(popup).data("index") == 3) {
            $(popup).addClass("more-info-popup-open-left");
        } else {
            $(popup).addClass("more-info-popup-open");
        }
        $(popup).removeClass("more-info-popup-close");
    });

    $(".close-popup").on("click", function (e) {
        $(".popup")
            .removeClass("more-info-popup-open-left", "more-info-popup-close")
            .addClass("more-info-popup-close");
    });

    // $(".tv_tariffs_packages_wrapper").slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 1500,
    //     dots: false,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 3.8,
    //                 infinite: true,
    //             },
    //         },
    //         {
    //             breakpoint: 960,
    //             settings: {
    //                 slidesToShow: 3.3,
    //             },
    //         },
    //         {
    //             breakpoint: 840,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 740,
    //             settings: {
    //                 slidesToShow: 2.7,
    //             },
    //         },
    //         {
    //             breakpoint: 660,
    //             settings: {
    //                 slidesToShow: 2.5,
    //             },
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 2.2,
    //             },
    //         },
    //         {
    //             breakpoint: 540,
    //             settings: {
    //                 slidesToShow: 2,
    //             },
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1.8,
    //             },
    //         },
    //         {
    //             breakpoint: 440,
    //             settings: {
    //                 slidesToShow: 1.6,
    //             },
    //         },
    //         {
    //             breakpoint: 400,
    //             settings: {
    //                 slidesToShow: 1.4,
    //             },
    //         },
    //     ],
    // });
    $slickchooseus = false;
    function chooseus_Slider() {
        if ($(window).width() < 1250) {
            if (!$slickchooseus) {
                $(".tv_tariffs_packages_wrapper").slick({
                    dots: false,
                    prevArrow: false,
                    nextArrow: false,
                    centerMode: false,
                    centerPadding: "60px",
                    infinite: false,
                    slidesToShow: 3,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    responsive: [
                        {
                            breakpoint: 850,
                            settings: {
                                arrows: false,
                                variableWidth: true,
                                centerMode: true,
                                centerPadding: "40px",
                                slidesToShow: 1,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: "40px",
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
                $slickchooseus = true;
            }
        } else if ($(window).width() > 1249) {
            if ($slickchooseus) {
                $(".tv_tariffs_packages_wrapper").slick("unslick");
                $slickchooseus = false;
            }
        }
    }

    $(function () {
        chooseus_Slider();
        $(window).resize(function () {
            chooseus_Slider();
        });
    });

    const faqItems = document.querySelectorAll(".faq-box");

    faqItems.forEach((item) =>
        item.addEventListener("click", () => {
            const answer = item.querySelector(".answer");
            const arrow = item.querySelector(".img_arrow");

            if (answer.style.maxHeight !== "100vh") {
                answer.style.maxHeight = "0vh";
                arrow.style.transform = "rotate(0deg)";
            } else {
                answer.style.maxHeight = "100vh";
                arrow.style.transform = "rotate(180deg)";
            }
        })
    );
});
